(function () {
  'use strict';

  if (customElements.get('before-after-slider')) return;

  customElements.define('before-after-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      this.pills = this.querySelectorAll('[data-pill-index]');

      const autoplay = parseInt(this.dataset.autoplay, 10) || 0;
      const pauseOnHover = this.dataset.pauseOnHover !== 'false';
      const slideCount = this.track ? this.track.children.length : 0;

      if (!this.track || slideCount <= 1 || !window.theme || !window.theme.Flickity) return;

      this._autoplay = autoplay;
      this._pauseOnHover = pauseOnHover;

      const firstCell = this.track.children[0];

      if (firstCell.offsetHeight > 0) {
        this._initFlickity();
        return;
      }

      // Slide height comes from an aspect-ratio CSS trick on <compare-images>
      // whose stylesheet is loaded async (preload+onload swap). Initialising
      // Flickity before the cell has resolved height yields a 0-height
      // viewport that never recovers. Defer init until first cell measures > 0.
      this._ro = new ResizeObserver(() => {
        if (firstCell.offsetHeight > 0) {
          this._teardownInitWatchers();
          if (!this.flkty) this._initFlickity();
        }
      });
      this._ro.observe(firstCell);

      this._initTimer = setTimeout(() => {
        this._teardownInitWatchers();
        if (!this.flkty) this._initFlickity();
      }, 1000);
    }

    _teardownInitWatchers() {
      if (this._ro) { this._ro.disconnect(); this._ro = null; }
      if (this._initTimer) { clearTimeout(this._initTimer); this._initTimer = null; }
    }

    _initFlickity() {
      this.flkty = new window.theme.Flickity(this.track, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        wrapAround: this._autoplay > 0,
        autoPlay: this._autoplay > 0 ? this._autoplay : false,
        pauseAutoPlayOnHover: this._pauseOnHover,
        draggable: true,
        adaptiveHeight: false,
        accessibility: true,
        on: {
          change: (i) => this._syncPills(i),
          resize: () => this._refreshCompareImages(),
        },
      });

      this._refreshCompareImages();

      this.pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          const i = parseInt(pill.dataset.pillIndex, 10);
          this.flkty.select(i);
          if (this._autoplay > 0) this.flkty.playPlayer();
        });
      });

      this._onResize = () => this.flkty && this.flkty.resize();
      document.addEventListener('theme:resize', this._onResize);
    }

    _syncPills(index) {
      this.pills.forEach((pill, i) => {
        const active = i === index;
        pill.classList.toggle('is-active', active);
        pill.setAttribute('aria-selected', String(active));
      });

      // Sync dynamic texts
      const section = this.closest('.section-before-after');
      if (section) {
        const texts = section.querySelectorAll('[data-text-index]');
        texts.forEach(el => {
          const textIndex = parseInt(el.getAttribute('data-text-index'), 10);
          el.classList.toggle('is-active', textIndex === index);
        });
      }
    }

    _refreshCompareImages() {
      this.querySelectorAll('compare-images').forEach((el) => {
        if (typeof el.setOverlapImageSize === 'function') {
          el.setOverlapImageSize();
        }
      });
    }

    disconnectedCallback() {
      this._teardownInitWatchers();
      if (this._onResize) document.removeEventListener('theme:resize', this._onResize);
      if (this.flkty) this.flkty.destroy();
    }
  });
})();
